import {connect} from 'react-redux';
import Notification from './notification';

export default connect(({
                            notifications, notiCount,
                            usersMap, issuesMap, token
                        }) =>
    ({
        notifications, notiCount,
        usersMap, issuesMap, token
    })
)
(Notification);


// WEBPACK FOOTER //
// ./src/components/notification/index.js